import {
  Box,
  Modal as MantineModal,
  Stack,
  Text,
  type ModalProps as MantineModalProps,
} from '@mantine/core';
import { IconX } from '@tabler/icons-react';
import { ReactNode } from 'react';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type Props = Omit<MantineModalProps, 'title' | 'withCloseButton'> & {
  title?: ReactNode;
  children: ReactNode;
};

const closeButtonStyle: React.CSSProperties = {
  position: 'absolute',
  top: 16,
  right: 16,
  width: 20,
  height: 20,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 0,
  border: 'none',
  borderRadius: 8,
  cursor: 'pointer',
  backgroundColor: 'var(--mantine-color-gray-10)',
};

export function Modal({ title, children, size = 389, styles, ...props }: Props) {
  return (
    <MantineModal
      {...props}
      size={size}
      centered
      withCloseButton={false}
      styles={{
        content: { borderRadius: 24 },
        body: { paddingTop: 32, paddingBottom: 32 },
        ...styles,
      }}
    >
      <Box
        component="button"
        type="button"
        aria-label="Close"
        onClick={props.onClose}
        style={closeButtonStyle}
      >
        <IconX size={16} color="var(--mantine-color-white)" />
      </Box>
      <Stack gap={0}>
        {title && (
          <Text size="displaySm" fw={FONT_WEIGHTS.semibold} c="black">
            {title}
          </Text>
        )}
        {children}
      </Stack>
    </MantineModal>
  );
}
